<script>
	import CustomCollapseCard from "src/components/CustomCollapseCard/CustomCollapseCard.svelte";
	import DamageCarousel from "src/components/ReportCard/DamageCarousel.svelte";
	import { isFQCaseOrigin } from "src/utils/misc";
	import { caseOriginDisplay } from "src/utils/options";

	let initialValues = {
		bookingImages: [
			{
				imgUrl: "",
				imgSide: "",
				isDamage: false,
			},
		],
	};

	export let caseDetails = {
		initialValues,
	};

	$: isApproving = caseDetails.status === "Approving";
	$: isPreBilling = caseDetails.status === "PreBilling";
	$: isQuoting = caseDetails.status === "Quoting";

	$: images = isFQCaseOrigin(caseDetails)
		? caseDetails.additionalPhotos
		: isApproving || isPreBilling || isQuoting
			? caseDetails.bookingImages
			: caseDetails.lastReviewed?.images || [];
</script>

<CustomCollapseCard
	customClass="mb-4"
	title={`${
		caseOriginDisplay[caseDetails.createdFrom || caseDetails.caseOrigin]
	} Photos/Videos`}
	isOpenDefault={true}
>
	{#if images?.length > 0}
		<DamageCarousel
			showImageTitle={false}
			damageAttributionEnabled={true}
			lightbox={true}
			data={{
				images: images.map((item) => ({
					imgUrl: item.imgUrl || item,
					imgSide: item.imgSide || "",
					isDamage: true,
				})),
			}}
		/>
	{:else}
		<div>
			<span> No media available </span>
		</div>
	{/if}
</CustomCollapseCard>
